import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";

import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";
import { Graphics,Sprite} from "pixi.js";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {bigWinEvents} from "../views/WinTextView";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import Timeline = gsap.Timeline;
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ImmortalFruitsReelController} from "../reel/ImmortalFruitsReelController";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";


export class ImmortalFruitsReelBackgroundView extends BaseView {
    private _reelsBg: Sprite;
    private betlinesBgLeft: Sprite;
    private betlinesBgRight: Sprite;
    private gameLogo:PIXI.spine.Spine;
    private leverYank:PIXI.spine.Spine;
    private _darkBg:Graphics;
    /**
     * @description To reset to normal state all the visible symbols of reel area when gamble is finished.
     */
    public static resetAllSymsToNormal(): void {
        const gameConfig: ImmortalFruitsGameConfig = ImmortalFruitsGameConfig.instance,
            len: number = gameConfig.SYMBOLS_NUM_IN_REEL[2];

        let symbol: StateReelSymbol,
            tl: Timeline | null = null;

        for (let i = 0; i < gameConfig.REELS_NUM; i++) {
            for (let j = 0; j < len; j++) {
                symbol = Reels.getSymbol(i, j)!;

                tl = symbol.changeState({
                    state: gameConfig.SYMBOL_STATES.normal
                });
            }

            // to maintain the depth of the symbols as per this game.
            tl && tl.add(() => (Reels.getReel(i)! as ImmortalFruitsReelController).reOrderSymbols());
        }
    }

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        EventHandler.addEventListener(this, bigWinEvents.PLAY_GREENLIGHTS, (event: GameEvent) => this.playIdleAimation(event.params[0]));
        EventHandler.addEventListener(this, bigWinEvents.STOP_GREENLIGHTS, (event: GameEvent) => this.stopIdleAnimation());
        EventHandler.addEventListener(this, bigWinEvents.LEVER_YANKING, (event: GameEvent) => this.playLeverYanking());
        const gameConfig: ImmortalFruitsGameConfig = ImmortalFruitsGameConfig.instance;
        this._darkBg = new Graphics();
        this._darkBg.name="reelAreaCover";
        // this._darkBg.beginFill(0xffffff,1);
        // this._darkBg.pivot.set(0, 0.5);
        // this._darkBg.drawRect(gameConfig.REEL_AREA_POS_X,gameConfig.REEL_AREA_POS_Y, gameConfig.REEL_AREA_WIDTH*0.93, gameConfig.REEL_AREA_HEIGHT);
         this._reelsBg = new PIXI.Sprite(GameResources.getTextures("reelArea")[0]);
        this.betlinesBgLeft = new PIXI.Sprite(GameResources.getTextures("betlinesBg")[0]);
        this.betlinesBgRight = new PIXI.Sprite(GameResources.getTextures("betlinesBg")[0]);
        this.gameLogo = new PIXI.spine.Spine(GameResources.getSpineAsset("gameLogo"));
        this.leverYank = new PIXI.spine.Spine(GameResources.getSpineAsset("leverYank"));
        this._reelsBg.anchor.set(0.5);
        this.betlinesBgLeft.anchor.set(0.5,0);
        this.betlinesBgRight.anchor.set(0.5,0);
        this.betlinesBgLeft.scale.set(1,0.99);
        this.betlinesBgRight.scale.set(1,0.99);
        this.gameLogo.pivot.set(0.5);
        this.leverYank.pivot.set(0.5);
        this._reelsBg.position.set(gameConfig.REEL_AREA_WIDTH / 2, gameConfig.GAME_HEIGHT / 2);
        this.betlinesBgLeft.position.set(gameConfig.REEL_AREA_POS_X-17.5, gameConfig.REEL_AREA_POS_Y-1);
        this.betlinesBgRight.position.set(gameConfig.REEL_AREA_WIDTH -23, gameConfig.REEL_AREA_POS_Y-1)
        this.leverYank.position.set(gameConfig.REEL_AREA_WIDTH+gameConfig.REEL_AREA_POS_X+16, gameConfig.REEL_AREA_POS_Y+gameConfig.SYMBOL_HEIGHT*1.5+15);

        StageManager.getLayer(gameConfig.LAYERS.REEL_BACKGROUND.name).addChild(this._reelsBg);
        StageManager.getLayer(gameConfig.LAYERS.REEL_BACKGROUND.name).addChild(this._darkBg);
        StageManager.getLayer(gameConfig.LAYERS.REEL_BACKGROUND.name).addChild(this.leverYank);
        StageManager.getLayer(gameConfig.LAYERS.REEL_BACKGROUND.name).addChild(this.betlinesBgLeft);
        StageManager.getLayer(gameConfig.LAYERS.REEL_BACKGROUND.name).addChild(this.betlinesBgRight);
        StageManager.getLayer(gameConfig.LAYERS.REEL_BACKGROUND.name).addChild(this.gameLogo);
        this.gameLogo.state.setAnimation(0, "logo_normal", false);

    }
    private playIdleAimation(animName:string){
        if(animName=="logo"||animName =="tiny" ||animName=="small"){
            this.gameLogo.state.setAnimation(0, "logo_animation", false).timeScale =1.3;
        }else if(animName=="medium"||animName =="large" ){
            this.gameLogo.state.setAnimation(0, "logo_animation", true).timeScale =1.3;
        }


    }
    private stopIdleAnimation(){
        this.gameLogo.state.setAnimation(0, "logo_normal", false);
    }
    protected onResize(resizeData: IResizeData): void {
        const gameConfig: ImmortalFruitsGameConfig = ImmortalFruitsGameConfig.instance;
        if (resizeData.orientation == Orientation.PORTRAIT) {
            this._darkBg.clear();
            this._darkBg.beginFill(0xe6e5df,0.8);
            this._darkBg.pivot.set(0, 0.5);
            this._darkBg.drawRect(gameConfig.REEL_AREA_POS_X,gameConfig.REEL_AREA_POS_Y-36-gameConfig.PORTRAIT_OFFSET, gameConfig.REEL_AREA_WIDTH*0.93, gameConfig.REEL_AREA_HEIGHT);
            this._reelsBg.scale.set(1);
            this.gameLogo.scale.set(1);
            this.gameLogo.position.set(ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH / 2,-this.gameLogo.height);
            this._reelsBg.position.set(ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH / 2, ImmortalFruitsGameConfig.instance.GAME_HEIGHT / 2-ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT/2);
            this.betlinesBgLeft.position.set(ImmortalFruitsGameConfig.instance.REEL_AREA_POS_X-17.5, ImmortalFruitsGameConfig.instance.REEL_AREA_POS_Y-36-ImmortalFruitsGameConfig.instance.PORTRAIT_OFFSET);
            this.betlinesBgRight.position.set(ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH -23, ImmortalFruitsGameConfig.instance.REEL_AREA_POS_Y-36-ImmortalFruitsGameConfig.instance.PORTRAIT_OFFSET);
        }else{
            this._darkBg.clear()
            this._darkBg.beginFill(0xe6e5df,0.8);
            this._darkBg.pivot.set(0, 0.5);
            this._darkBg.drawRect(gameConfig.REEL_AREA_POS_X,gameConfig.REEL_AREA_POS_Y, gameConfig.REEL_AREA_WIDTH*0.93, gameConfig.REEL_AREA_HEIGHT);
            this.gameLogo.scale.set(0.9);
            this.gameLogo.position.set(-150,ImmortalFruitsGameConfig.instance.GAME_HEIGHT / 2-ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT/2-160);
            this._reelsBg.position.set(ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH / 2, ImmortalFruitsGameConfig.instance.GAME_HEIGHT / 2+15);
            this.betlinesBgLeft.position.set(ImmortalFruitsGameConfig.instance.REEL_AREA_POS_X-17.5, ImmortalFruitsGameConfig.instance.REEL_AREA_POS_Y-1);
            this.betlinesBgRight.position.set(ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH -23, ImmortalFruitsGameConfig.instance.REEL_AREA_POS_Y-1);
        }

        if(resizeData.orientation === Orientation.LANDSCAPE) {
            if((NolimitApplication.screenBounds.left > this.gameLogo.position.x) || !(Helper.isDefaultScreenRatio(NolimitApplication.screenBounds))) {
                this.gameLogo.renderable = false;
            } else {
                this.gameLogo.renderable = true;
            }
        }else{
            if (!(Helper.isDefaultScreenRatio(NolimitApplication.screenBounds))) {
                this.gameLogo.renderable = false;
            }else {
                this.gameLogo.renderable = true;
                this.gameLogo.position.set(NolimitApplication.screenBounds.center, -this.gameLogo.height / 2 -20);
            }
        }
        this._darkBg.alpha =0;
    }
    private playLeverYanking(){
        this.leverYank.state.setAnimation(0, "lever_yank", false);
    }
}